$(window).on('load', () => {
  $('.hamburger').on('click', function() {
    $(this).toggleClass('active');
    $('.header__nav').toggleClass('active');
    $('body').toggleClass('active');
  });
});
